import { UserNotification, UserNotificationUtilService } from "@scisys-uim/uim-common";

export class SystemMessageNotificationUtilService implements UserNotificationUtilService {

  unableToDismissReason(notification?: UserNotification): string {
    return "";
  }

  canBeDismissed(notification: UserNotification): boolean {
    return true;
  }

  getUserMessageType(): string {
    return "SystemMessage";
  }

  getRouteFromLinkData(notification: UserNotification): any[] {
    return null;
  }

  getRouteLinkQueryParams(notification: UserNotification) {
    return {};
  }

}
